<template>
  <div class="content page-vipRights_intro-firstPay">
    <div class="fs16">
      <img class="vam" src="~assets/img/right/intro_2.png" alt="icon" />
      <span v-if="userLevel().level !== undefined" class="vam ml10"
        >您是尊贵的VIP{{ userLevel().level }}玩家，每月拥有{{
          getLevelGap().count
        }}次免费领首充机会</span
      >
      <span v-else class="vam ml10"> 您尚未激活会员 </span>
    </div>
    <div class="mt30 clearfix">
      <div class="tip-area fl">
        本月剩余次数：<em class="red">{{ getLevelGap().count - payCount }}</em>
        次
      </div>
      <div class="tip-area fl ml18">
        本月已领取次数：<em class="red">{{ payCount }}</em> 次
      </div>
    </div>
    <div class="mt30">
      <Tabs @tab-click="changeTab">
        <TabPane label="领取首充">
          <div class="mt30">
            <SelectRole
              ref="selectRole"
              dir="vertical"
              :filter-pay-status="true"
            />
            <button class="btn btn-primary mt10" @click="confirm">
              立即领取
            </button>
            <!-- <div class="line mt30"></div>
            <div class="mt30 fs14">
              礼包内容：极品武器、极品技能、人物直升一级丹、英雄直升一级丹、首充礼包。
            </div> -->
          </div>
        </TabPane>
        <TabPane label="领取记录">
          <div class="mt20">
            <table v-if="records.length" class="fs14 tl">
              <thead>
                <tr>
                  <th width="170px">领取时间</th>
                  <th width="170px">领取游戏</th>
                  <th width="170px">游戏区服</th>
                </tr>
              </thead>
              <tbody class="gray">
                <tr v-for="item in records" :key="item.id" style="height: 40px">
                  <td>{{ $dayjs(item.created_at).format('YYYY-MM-DD') }}</td>
                  <td>{{ item.game_title }}</td>
                  <td>{{ item.server_title }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else class="gray tc">暂无领取记录</div>
            <Pagination :page="pages" :index="page" @change="fetchRecords" />
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import SelectRole from '~/components/logic-common/SelectRole/main'
import Pagination from '~/components/common/Pagination'
export default {
  components: {
    SelectRole,
    Pagination
  },
  data() {
    return {
      pages: 1,
      page: 1,
      pageSize: 10,
      payCount: 0,
      records: []
    }
  },
  inject: ['getLevelGap', 'userLevel'],
  methods: {
    confirmNotify(message) {
      this.$notify({
        message,
        duration: 0
      })
    },
    clientCreated() {
      if (this.$store.getters.isLogin) {
        // this.fetchRecords(this.page)
        this.fetchCurCount()
      }
    },
    changeTab(val) {
      if (val === '1') {
        this.fetchRecords(1)
        this.fetchCount()
      }
    },
    confirm() {
      const { curGame, curArea, curRole } = this.$refs.selectRole
      if (!this.$store.getters.isLogin) {
        return this.$login()
      }
      if (!curArea.server_id) {
        return this.$notify('请选择区服')
      }
      if (!curRole.role_name) {
        return this.$notify('请选择角色')
      }
      this.$request(
        'sendGiftRecharge',
        {
          body: {
            game_id: curGame.game_id,
            server_id: curArea.server_id,
            role_id: curRole.role_id
            // value: 1
          }
        },
        { showNotify: true }
      )
        .then((data) => {
          this.$notify({
            type: 'success',
            message: '奖励发送成功'
          })
          this.fetchCurCount()
        })
        .catch((err) => {
          let message = err.message
          if (err.code === 30111) {
            message = '您还不是尊贵的迅玩VIP用户哦，暂时享受不了平台首充特权。'
            return this.confirmNotify(message)
          }
          if (err.code === 30109) {
            message =
              '请到会员特权首页-头像下方-点击激活VIP，激活完成后即可领取首充特权哦~'
            return this.confirmNotify(message)
          }
          if (this.getLevelGap().count === this.payCount) {
            message = '您本月首充奖励已领完'
            return this.confirmNotify(message)
          }
          if (err.code === 30110) {
            message =
              '您已领取过该游戏区服的首充特权，单游戏区服仅限领取一次哦~'
            return this.confirmNotify(message)
          }
        })
    },
    fetchRecords(page) {
      this.$request('queryGiftRecharge', {
        body: {
          page,
          size: this.pageSize
        }
      }).then((data = {}) => {
        this.page = page
        this.records = (data.list || []).map((e) => {
          const { game_title = '--', title = '--' } = this.$util.getServerById(
            e.game_id,
            e.server_id
          )
          return {
            ...e,
            game_title,
            server_title: title
          }
        })
      })
    },
    fetchCount() {
      this.$request('queryGiftRechargeCount').then((data = {}) => {
        this.pages = Math.ceil(data.count / this.pageSize)
      })
    },
    fetchCurCount() {
      this.$request('queryGiftRechargeCount', {
        body: { current_month: 1 }
      }).then((data = {}) => {
        this.payCount = data.count
      })
    }
  }
}
</script>
